export default __webpack_public_path__ + "static/media/caret-down-sm.c2d3dd4d.svg";